import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Layout from "@/components/Layout";
import Dashboard from "@/pages/Dashboard";
import Terminals from "@/pages/Terminals";
import Vessels from "@/pages/Vessels";
import PortCalls from "@/pages/PortCalls";
import PortCallDetail from "@/pages/PortCallDetail";
import Assets from "@/pages/Assets";
import Personnel from "@/pages/Personnel";
import Sops from "@/pages/Sops";
import AuditLog from "@/pages/AuditLog";
import Timeline from "@/pages/Timeline";
import VisionStats from "@/pages/VisionStats";
import LaborKnowledge from "@/pages/LaborKnowledge";
import HelpCenter from "@/pages/HelpCenter";
import TerminalMapPopout from "@/pages/TerminalMapPopout";

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/terminals/:id/popout" element={<TerminalMapPopout />} />
        <Route path="/*" element={(
          <Layout>
            <Routes>
              <Route path="/" element={<Dashboard />} />
              <Route path="/terminals" element={<Terminals />} />
              <Route path="/vessels" element={<Vessels />} />
              <Route path="/port-calls" element={<PortCalls />} />
              <Route path="/port-calls/:id" element={<PortCallDetail />} />
              <Route path="/timeline" element={<Timeline />} />
              <Route path="/assets" element={<Assets />} />
              <Route path="/personnel" element={<Personnel />} />
              <Route path="/sops" element={<Sops />} />
              <Route path="/labor-knowledge" element={<LaborKnowledge />} />
              <Route path="/audit" element={<AuditLog />} />
              <Route path="/vision" element={<VisionStats />} />
              <Route path="/help" element={<HelpCenter />} />
            </Routes>
          </Layout>
        )} />
      </Routes>
    </BrowserRouter>
  );
}
